import { create } from 'zustand';
import { Property, PropertyFilters } from '../types/property';

interface PropertyState {
  properties: Property[];
  favorites: string[];
  filters: PropertyFilters;
  setProperties: (properties: Property[]) => void;
  toggleFavorite: (propertyId: string) => void;
  setFilters: (filters: Partial<PropertyFilters>) => void;
  resetFilters: () => void;
}

const defaultFilters: PropertyFilters = {};

export const usePropertyStore = create<PropertyState>((set) => ({
  properties: [],
  favorites: [],
  filters: defaultFilters,
  
  setProperties: (properties) => set({ properties }),
  
  toggleFavorite: (propertyId) =>
    set((state) => ({
      favorites: state.favorites.includes(propertyId)
        ? state.favorites.filter((id) => id !== propertyId)
        : [...state.favorites, propertyId],
    })),
  
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  
  resetFilters: () => set({ filters: defaultFilters }),
}));
